var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #000000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M423.92 171.86C423.92 171.26 423.92 170.66 423.92 170.06C423.96 94.94 363.1 34.03 287.99 33.99C242.3 33.97 199.66 56.89 174.47 95C124.12 78.19 69.68 105.39 52.87 155.74C49.61 165.51 47.94 175.75 47.92 186.06C47.92 186.74 47.92 187.42 47.92 188.11C13.71 197 -6.82 231.94 2.07 266.15C9.39 294.33 34.81 314.01 63.92 314.06L207.4 314.06C211.81 314.06 215.4 310.47 215.4 306.06C215.4 301.64 211.81 298.06 207.4 298.06L63.92 298.06C37.41 297.9 16.05 276.28 16.21 249.77C16.35 226.01 33.86 205.92 57.39 202.54C61.62 201.98 64.66 198.18 64.29 193.93C64.08 191.35 63.92 188.7 63.92 186.06C63.98 141.82 99.89 106 144.13 106.06C154.62 106.07 165.01 108.14 174.7 112.16C178.37 113.69 182.61 112.28 184.64 108.86C218.39 51.82 291.98 32.94 349.02 66.68C385.56 88.3 407.96 127.61 407.92 170.06C407.92 172.7 407.85 175.27 407.64 177.85C407.26 182.15 410.38 185.97 414.67 186.48C445.36 190.28 467.16 218.24 463.37 248.93C459.9 276.94 436.14 297.99 407.92 298.06C405.52 298.06 403.11 297.92 400.72 297.63C399.58 297.49 398.41 297.64 397.33 298.06L271.64 298.06C267.22 298.06 263.64 301.64 263.64 306.06C263.64 310.47 267.22 314.06 271.64 314.06L399.92 314.06C400.54 314.05 401.14 313.97 401.73 313.81C403.76 313.98 405.83 314.06 407.92 314.06C447.69 314.06 479.93 281.82 479.93 242.06C479.93 208.46 456.69 179.32 423.92 171.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M302.15 364.4L247.92 418.62L247.92 194.06C247.92 189.64 244.34 186.06 239.92 186.06C235.51 186.06 231.92 189.64 231.92 194.06L231.92 418.62L177.7 364.4C174.52 361.33 169.46 361.42 166.39 364.6C163.39 367.7 163.39 372.61 166.39 375.71L234.27 443.59C237.39 446.71 242.46 446.71 245.58 443.59L313.46 375.71C316.53 372.53 316.44 367.47 313.26 364.4C310.16 361.4 305.25 361.4 302.15 364.4Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.93228443.svg";
export { ForwardRef as ReactComponent };